import React, { Component } from 'react';
import * as SupplierCallInAction from '../actions/SupplierCallInAction';
import SupplierCallInStore from '../stores/SupplierCallInStore';
import * as CookieService from '../CookieService';
import Select from 'react-select';
import SDIConstants from '../SDIConstants';
import * as $ from 'jquery';
import * as ShoppingCartAction from '../actions/ShoppingCartAction';
import ShoppingCartStore from '../stores/ShoppingCartStore';
import QuickItemComponent from '../components/QuickItemComponent';
import * as MenuAction from '../actions/MenuAction';
import BreadCrumpData from '../stores/BreadCrumpStore';
import WOPartsComponent from '../components/WOPartsComponent';
//import { Translator, Translate } from 'react-auto-translate';
import { withTranslation, Trans } from 'react-i18next'
import i18n from '../i18n';
import swal from 'sweetalert';
let rmvAttachindex = -1;
let currentPagePath;
const cacheProvider = {
    get: (language, key) =>
        ((JSON.parse(localStorage.getItem('translations')) || {})[key] || {})[
        language
        ],
    set: (language, key, value) => {
        const existing = JSON.parse(localStorage.getItem('translations')) || {
            [key]: {},
        };
        existing[key] = { ...existing[key], [language]: value };
        localStorage.setItem('translations', JSON.stringify(existing));
    },
};

class SupplierCallInComponent extends Component {

    constructor(props) {
        super(props);
        this.handleFavorite = this.handleFavorite.bind(this);
        this.bindAttachments = this.bindAttachments.bind(this);
        this.supplierCallInpageload = this.supplierCallInpageload.bind(this); //WW-920_PC_29 (same API is going to be in interactive diagram)

        //WAL-1034_PC_44 -Aparna
        this.AnykeyPress = this.AnykeyPress.bind(this);
        this.WOText = React.createRef();
        this.state = {
            bill_to: false,
            woclick: false,
            defaultShipto: "",
            ShipToDDValue: [],
            StatusMsgbilltostore: "",
            isWorkToStoreValid: false,
            BilltoStore: "",
            OLShipToIdLabel: "Ship To",
            isFavorited: false,
            Page_ID: "",
            AssetID: localStorage.getItem("WOAssetID") != null ? JSON.parse(localStorage.getItem("WOAssetID")) : "Enter Asset ID", /*[04/10/23, PC_4247_03, Vishwa S]*/
            VendorIDList: [],
            VendorIDList1: [],
            VendorID: "0",
            VendorDetail: [],
            VendorDetail1: [],
            Address: "",
            Phoneno: "",
            WorkOrderNo: localStorage.getItem("WONum") != null ? JSON.parse(localStorage.getItem("WONum")) : "",
            Store: (CookieService.getLocalStorageValues("WO_Address") == "" ? CookieService.getLocalStorageValues("WO_Address") : CookieService.getLocalStorageValues("WO_Address")),
            Make: "",
            Model: "",
            SerialNo: "",
            Make1: "",
            Model1: "",
            SerialNo1: "",
            Notes: "",
            WONotes: "",
            oldlang: "",
            language: "",
            Validcheck: true,
            WORmsg: false,
            WOmsg: false,
            assetmsg: false,
            vendormsg: false,
            addressmsg: false,
            shiptomessg: false,
            phoneNumBol: false,
            billtostorelocation: {},
            storetruckval: "",
            curtrucklat: "",
            curtrucklong: "",
            Shipto: "",
            AssetName: "",
            AssetName1: "",
            AllShipTo: [],
            Location: localStorage.getItem("StoreValue") != null ? JSON.parse(localStorage.getItem("StoreValue")) : "",
            EmployeeID: (CookieService.getLocalStorageValues("Session_AGENTUSERID") == "" ? CookieService.getLocalStorageValues("Session_UserID") : CookieService.getLocalStorageValues("Session_AGENTUSERID")),
            WorkOrderResponse: [], pickupcheck: false, Pickupdisplay: false, isFavorited: false, attachmentPathArr: [],
            Address3Field: "", WO_Parts: localStorage.getItem("WO_Parts") != null && localStorage.getItem("WO_Parts") != undefined && localStorage.getItem("WO_Parts") != "" ? JSON.parse(localStorage.getItem("WO_Parts")) : [], //Bug :3618
            isValidWO: localStorage.getItem("WONum") != null ? true : false
        }
    };
    componentDidMount() {
        window.scrollTo(0, 0)
        CookieService.updateLocalStorageValues("Session_PageName", window.location.pathname);
        CookieService.updateLocalStorageValues("pageName", "Supplier");
        /*[04/10/23, PC_4247_05 - To disable AssetID field, Vishwa S]*/
        if ((this.state.AssetID === "NONE" && this.state.WorkOrderNo === "") || (this.state.AssetID !== "NONE" && this.state.WorkOrderNo !== "")) {
            $("#AssetID").attr("disabled", true);
        }
        $("#Phoneno").attr("disabled", true);
        currentPagePath = this.props.location.pathname;
        currentPagePath = currentPagePath.indexOf("?") >= 0 ? currentPagePath.split("?")[0] : currentPagePath;
        let getFavPageBO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            pageURL: "/suppliercallin",
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        SupplierCallInAction.getCurrentFavPage(getFavPageBO);
        this.GetPageLoad();
        //WAL-1034_PC_
        if (localStorage.getItem("WONum") != null) {
            $("#WorkOrderNo").addClass("disabledbutton");
            this.setShipToDD(JSON.parse(localStorage.getItem("BilltoStoreLocationLat")), JSON.parse(localStorage.getItem("BilltoStoreLocationLong")))
        }
        ShoppingCartStore.on("Cartitem", this.BuildSupplierCallPage);
        SupplierCallInStore.on('Pageload', this.supplierCallInpageload);
        SupplierCallInStore.on('Insert', this.supplierCallInSubmit);
        SupplierCallInStore.on('favpage', this.loadFavPageResponse);
        SupplierCallInStore.on('updateFavPage', this.updateFavPageResponse);
        ShoppingCartStore.on("latlongresp", this.trucklatlong);
        //ShoppingCartStore.on("workordercheck", this.Workorderresponse);
        SupplierCallInStore.on('workordercheck', this.Workorderresponse);
        SupplierCallInStore.on('WOfail', this.workorderfail);
        SupplierCallInStore.on('attachmentResponse', this.loadAttachments);
        SupplierCallInStore.on('rmvAttach', this.removeAttachmentResponse);
    }
    componentWillUnmount() {
        SupplierCallInStore.removeListener('WOfail', this.workorderfail);
        ShoppingCartStore.removeListener("Cartitem", this.BuildSupplierCallPage);
        ShoppingCartStore.removeListener("latlongresp", this.trucklatlong);
        //ShoppingCartStore.removeListener("workordercheck", this.Workorderresponse);
        SupplierCallInStore.removeListener('workordercheck', this.Workorderresponse);
        SupplierCallInStore.removeListener('updateFavPage', this.updateFavPageResponse);
        SupplierCallInStore.removeListener('Pageload', this.supplierCallInpageload);
        SupplierCallInStore.removeListener('Insert', this.supplierCallInSubmit);
        SupplierCallInStore.removeListener('favpage', this.loadFavPageResponse);
        SupplierCallInStore.removeListener('attachmentResponse', this.loadAttachments);
        SupplierCallInStore.removeListener('rmvAttach', this.removeAttachmentResponse);
    }
    GetPageLoad = () => {
        let localasset = "";
        let loacalloc = "";
        //[11/9/22, WAL - 785 - Passing BU as a object, Dhevanesam R]
        let BO = {
            AssetId: localasset,
            SHIPTO: loacalloc,
            BU: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            IsWeb: true,
            userID: CookieService.getLocalStorageValues("Session_UserID")
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        SupplierCallInAction.SupplierAsset(BO)
    }
    supplierCallInpageload = () => {
        let vendordetailresponse = JSON.parse(SupplierCallInStore.vendordetail);
        let vendor = [];
        let MMS = [];
        let make = "";
        let model = "";
        let serial = "";
        let vendordropdown = [];
        let assetname = "";
        let locCountryMatch = true;
        if (vendordetailresponse) {
            if (vendordetailresponse.Vendortable.length > 0) {
                vendor = vendordetailresponse.Vendortable;
                vendordropdown = vendor.filter((v, i, a) => a.findIndex(t => (t.NAME1.trim().toUpperCase() === v.NAME1.trim().toUpperCase())) === i)
                console.log("vendorDD", vendordropdown);
            }
            if (vendordetailresponse.SupplierOrderEntrytable.length > 0) {
                MMS = vendordetailresponse.SupplierOrderEntrytable;
                if (MMS[0].ISA_ASSET_MFG) {
                    make = MMS[0].ISA_ASSET_MFG;
                }
                if (MMS[0].ISA_ASSET_MFG_ITM) {
                    model = MMS[0].ISA_ASSET_MFG_ITM;
                }
                if (MMS[0].ISA_ASSET_SERIALID) {
                    serial = MMS[0].ISA_ASSET_SERIALID;
                }
                if (MMS[0].DESCR) {
                    assetname = MMS[0].DESCR;
                }
                console.log("vendorDD", vendordropdown);
            }
        }
        let Defaultship = CookieService.getLocalStorageValues("Session_ISAShipToID") == null || CookieService.getLocalStorageValues("Session_ISAShipToID") == "" ? "0" : CookieService.getLocalStorageValues("Session_ISAShipToID");
        let OLShipToIdLabelLocal = "Ship To";
        let ShiptoValue = []
        let PerferedShipto = {
            value: "0",
            label: "--Select Ship To--"
        }
        //WW-1020 - User is able to select #1822 Ship To (PR) for #1519 Work Order (USA) - Deepthi
        let LocShiptValue = [];
        let countryCode = CookieService.getLocalStorageValues("LOCATION");
        let DefShipTo = vendordetailresponse.ShipToDD.filter((item, index) => item.CUSTID.toUpperCase() == Defaultship.toUpperCase());
        if (DefShipTo.length > 0) {
            if (countryCode.toUpperCase() == DefShipTo[0].COUNTRY.toUpperCase()) {
                let locDefShipTo = {
                    value: DefShipTo[0].CUSTID,
                    label: DefShipTo[0].LOCNAME
                }
                PerferedShipto = locDefShipTo;
            } else {
                locCountryMatch = false;
            }

        }

        if (localStorage.getItem("WONum") != null) {
            let CountryCode = CookieService.getLocalStorageValues("LOCATION");
            if (CountryCode.toUpperCase() == "PRI") {
                LocShiptValue = vendordetailresponse.ShipToDD.filter((item, index) => item.COUNTRY.toUpperCase() == "PRI");
            }
            else {
                LocShiptValue = vendordetailresponse.ShipToDD.filter((item, index) => item.COUNTRY.toUpperCase() == CountryCode.toUpperCase());
            }
        }
        else {
            LocShiptValue = vendordetailresponse.ShipToDD;
        }
        if (LocShiptValue.length > 0) {
            LocShiptValue.map((val, index) => {
                if (index == 0) {
                    let defaultvalue = {
                        value: "0",
                        label: "--Select Ship To--"
                    }
                    ShiptoValue.push(defaultvalue)
                }
                let localArray = {
                    value: val.CUSTID,
                    label: val.LOCNAME
                }
                //if (val.CUSTID == Defaultship) {
                //    PerferedShipto = localArray
                //}
                ShiptoValue.push(localArray)

            });
        }
        this.setState({
            VendorIDList1: vendordropdown, VendorDetail1: vendor, Make1: make, Model1: model, SerialNo1: serial, AssetName1: assetname, isCountryMatch: locCountryMatch,
            OLShipToIdLabel: OLShipToIdLabelLocal, ShipToDDValue: ShiptoValue, defaultShipto: PerferedShipto.value === "W09301" || PerferedShipto.value === "W02409" ? { value: "0", label : "-- Select Ship To --" } : PerferedShipto, AllShipTo: vendordetailresponse.ShipToDD
        });
        if (localStorage.getItem("WONum") != null) {
            this.setState({ VendorIDList: vendordropdown, VendorDetail: vendor, Make: model, Model: model, SerialNo: serial, AssetName: assetname })

        }
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }
    BuildSupplierCallPage = () => {

        let PageLaod_Data = JSON.parse(ShoppingCartStore.CartitemList);
        let OLShipToIdLabelLocal = "Ship To";
        let EnterprisesTable = PageLaod_Data.EnterpriseTable;
        let showShiptoTable = PageLaod_Data.showShipto;
        let ShipDD = [];
        let locCountryMatch = true;
        ShipDD = PageLaod_Data.ShipToDD;
        if ((EnterprisesTable[0].ShipToFlag == "Y" && showShiptoTable[0].Show == "true") || ShipDD.length > 1) {
            OLShipToIdLabelLocal = "* Ship To";
        }
        let Defaultship = CookieService.getLocalStorageValues("Session_ISAShipToID") == null || CookieService.getLocalStorageValues("Session_ISAShipToID") == "" ? "0" : CookieService.getLocalStorageValues("Session_ISAShipToID");

        let ShiptoValue = []
        let PerferedShipto = {
            value: "0",
            label: "--Select Ship To--"
        }
        if (PageLaod_Data.ShipToDD.length > 0) {
            PageLaod_Data.ShipToDD.map((val, index) => {
                if (index == 0) {
                    let defaultvalue = {
                        value: "0",
                        label: "--Select Ship To--"
                    }
                    ShiptoValue.push(defaultvalue)
                }
                let localArray = {
                    value: val.CUSTID,
                    label: val.LOCNAME
                }
                if (val.CUSTID == Defaultship) {
                    if (val.COUNTRY == Defaultship.touppercase()) {
                        PerferedShipto = localArray
                    }
                    else {
                        locCountryMatch = false;
                    }
                }
                ShiptoValue.push(localArray)

            });
        }

        this.setState({
            OLShipToIdLabel: OLShipToIdLabelLocal,
            ShipToDDValue: ShiptoValue,
            defaultShipto: PerferedShipto,
            isCountryMatch: locCountryMatch
        });

        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }
    BuildShipToDD = () => {

        let Defaultship = this.state.defaultShipto;
        return this.state.ShipToDDValue.map((iresult, index) => {
            //if (iresult != null && iresult != undefined && this.state.ShipToDDValue.length > 1) {
            //    return (<option key={iresult.CUSTID} value={iresult.CUSTID}>{iresult.LOCNAME}</option>)

            //}
            if (this.state.ShipToDDValue.length < 2) {

                return (<input type="text" key="1" className="form-control" placeholder="Enter Location" defaultValue={iresult.label} id="OLShipTo" readOnly />)
                //$("#OLShipTo").attr("disabled", "disabled"); 
            }
        });
        if (Defaultship != "" && Defaultship != null) {
            $('#OLShipTo').val(Defaultship);
            //document.getElementById("OLShipTo"). = true
        }
        let billtoStore = this.state.BilltoStore;
        if (billtoStore != "" && billtoStore != null) {
            $('#OLShipTo').val(billtoStore);
            this.setState({ defaultShipto: billtoStore });
        }

    }
    supplierCallInSubmit = () => {
        let submit = JSON.parse(SupplierCallInStore.insertResponse);
        if (submit) {
            if (submit[0].ReqID != "") {
                console.log(submit[0]);
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Your request is inserted successfully.\nRequest Id: " + submit[0].ReqID
                });
                //  alert("Your request is inserted successfully.\nRequest Id: "+submit[0].ReqID);              
                // this.CancelBtnClick();
                this.props.history.push({
                    pathname: `/HomePage`,
                    search: ``
                });
            }
            else {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Enter valid Assetid"
                });
                // alert("Enter valid Assetid")
            }
        }
    }
    workorderfail = () => {


        // alert("Enter valid Work Order Number");
        $(`#WorkOrderNo`).val('');
        this.setState({
            isWorkToStoreValid: false, WorkOrderNo: "", WOmsg: "Enter a valid Work order number" //WW-719_PC_32 -Aparna
        })
        //this.setState({ isWorkToStoreValid: false});
        //document.getElementById('StatusMsgbilltostore').innerText = "Enter valid work order number"
        document.getElementById('StatusMsg1').innerText = " "
    }
    Workorderresponse = () => {

        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        localStorage.setItem('WONum', this.state.WorkOrderNo);
        let Workorderresponse = JSON.parse(SupplierCallInStore.workorderresponse);
        let localasset = "";
        let workorder = [];
        let localstore = "";
        let localWON = "";
        let loacalloc = "";
        let LWOmsg = false;
        let validation = false;
        let localloc = "";
        let BilltoStoreLocationLat = 0;
        let BilltoStoreLocationLong = 0;
        console.log("workorder", Workorderresponse);
        if (Workorderresponse.WOResponse) {
            if (Workorderresponse.WOResponse.length > 0) {
                workorder = Workorderresponse.WOResponse;
                CookieService.updateLocalStorageValues("Trade", Workorderresponse.WOResponse[0].Trade);
                /*[12/24/21, PC_SC_02], Priyanka D//Updating the Location storage*/
                let homestoreloc = CookieService.getLocalStorageValues("LOCATION");
                CookieService.updateLocalStorageValues("homestoreloc", homestoreloc);
                CookieService.updateLocalStorageValues("LOCATION", Workorderresponse.WOResponse[0].COUNTRY);
                localStorage.setItem("Country", Workorderresponse.WOResponse[0].COUNTRY);
                //WW-591_PC_02 -Aparna
                CookieService.updateLocalStorageValues("WO_Category", Workorderresponse.WOResponse[0].Category);
                CookieService.updateLocalStorageValues("WO_Priority", Workorderresponse.WOResponse[0].Priority);
                CookieService.updateLocalStorageValues("NTEAmount", Workorderresponse.WOResponse[0].NTE);
                CookieService.updateLocalStorageValues("WO_CAT_DESC", Workorderresponse.WOResponse[0].WO_CAT_DESC);
                CookieService.updateLocalStorageValues("WO_Type", Workorderresponse.WOResponse[0].WO_Type);
                CookieService.updateLocalStorageValues("Session_WO_STATE", Workorderresponse.WOResponse[0].STATE); //WW-1231 WO State Restriction -Vishwa S
                CookieService.updateLocalStorageValues("IsBlanketWO", Workorderresponse.WOResponse[0].IsBlanketWO);// Set stating the ship to value to ISBlanketWO when the user selects the ship to as W09301

                //WW-1374 Update the WO logo, Problem code long and short description to cookie - Nandhini L 
                CookieService.updateLocalStorageValues("Logo", Workorderresponse.WOResponse[0].Logo);
                CookieService.updateLocalStorageValues("ProblemCodeDescription", Workorderresponse.WOResponse[0].ProblemCodeDescription);
                CookieService.updateLocalStorageValues("Description", Workorderresponse.WOResponse[0].Description);

                if (Workorderresponse.WOResponse[0].ADDRESS1 != "" && Workorderresponse.WOResponse[0].ADDRESS1 != null && Workorderresponse.WOResponse[0].ADDRESS1 != undefined && Workorderresponse.WOResponse[0].ADDRESS1 != " ") {
                    localstore = Workorderresponse.WOResponse[0].ADDRESS1
                    CookieService.updateLocalStorageValues("WO_Address", Workorderresponse.WOResponse[0].ADDRESS1);
                    validation = true;
                    loacalloc = Workorderresponse.WOResponse[0].LOCATION
                    if (Workorderresponse.WOResponse[0].AssetID != "" && Workorderresponse.WOResponse[0].AssetID != null && Workorderresponse.WOResponse[0].AssetID != undefined && Workorderresponse.WOResponse[0].AssetID != " ") {
                        localStorage.setItem('WOAssetID', Workorderresponse.WOResponse[0].AssetID); /*[04/10/23, PC_4247_04 - To store AssetID in localStorage, Vishwa S]*/
                        localStorage.setItem('WOAssetTag', Workorderresponse.WOResponse[0].AssetTag);
                        localasset = Workorderresponse.WOResponse[0].AssetID;
                        $("#AssetID").attr("disabled", true);
                        console.log("AssetID", Workorderresponse.WOResponse[0].AssetID);
                        if (Workorderresponse.WOResponse[0].WO_Make != "" && Workorderresponse.WOResponse[0].WO_Make != null && Workorderresponse.WOResponse[0].WO_Make != undefined && Workorderresponse.WOResponse[0].WO_Make != " ") {
                            CookieService.updateLocalStorageValues("WO_Make", Workorderresponse.WOResponse[0].WO_Make);
                        } if (Workorderresponse.WOResponse[0].WO_Model != "" && Workorderresponse.WOResponse[0].WO_Model != null && Workorderresponse.WOResponse[0].WO_Model != undefined && Workorderresponse.WOResponse[0].WO_Model != " ") {
                            CookieService.updateLocalStorageValues("WO_Model", Workorderresponse.WOResponse[0].WO_Model);
                        }
                    }
                    else {
                        $("#AssetID").attr("disabled", false);

                    }
                    if (Workorderresponse.WOResponse[0].LOCATION != "" && Workorderresponse.WOResponse[0].LOCATION != null && Workorderresponse.WOResponse[0].LOCATION != undefined && Workorderresponse.WOResponse[0].LOCATION != " ") {
                        loacalloc = Workorderresponse.WOResponse[0].LOCATION
                        localStorage.setItem("StoreValue", JSON.stringify(loacalloc));
                        BilltoStoreLocationLat = Workorderresponse.WOResponse[0].LATITUDE;
                        BilltoStoreLocationLong = Workorderresponse.WOResponse[0].LONGITUDE;
                        localStorage.setItem("BilltoStoreLocationLat", BilltoStoreLocationLat);
                        localStorage.setItem("BilltoStoreLocationLong", BilltoStoreLocationLong);
                        console.log("loacalloc", loacalloc);
                    }
                    if (Workorderresponse.WOResponse[0].Notes != "" && Workorderresponse.WOResponse[0].Notes != null && Workorderresponse.WOResponse[0].Notes != undefined && Workorderresponse.WOResponse[0].Notes != " ") {
                        localWON = Workorderresponse.WOResponse[0].Notes;
                        //$("#AssetID").attr("disabled", true);
                        console.log("Notes", Workorderresponse.WOResponse[0].Notes);

                    }
                    //else {
                    //    //$("#AssetID").attr("disabled", false);
                    //}
                }
                else {
                    validation = false;
                    LWOmsg = true;
                    $("#AssetID").attr("disabled", true);
                    //alert("Enter valid Work Order No")
                }
                let locWO_Parts = []
                if (Workorderresponse.WOParts != undefined && Workorderresponse.WOParts != null) {

                    if (Workorderresponse.WOParts.length > 0) {
                        // CookieService.updateLocalStorageValues("WO_Parts", Workorderresponse.WOParts);
                        localStorage.setItem("WO_Parts", JSON.stringify(Workorderresponse.WOParts)) //BUG:3618 -Aparna
                        locWO_Parts = Workorderresponse.WOParts
                        let parts = CookieService.getLocalStorageValues("WO_Parts")
                        $('#WO_Parts_Popup').modal('show');

                    }
                }
                this.setState({ WO_Parts: locWO_Parts });
                $("#WorkOrderNo").addClass("disabledbutton");

            }
            if (validation) {

                this.setShipToDD(Workorderresponse.WOResponse[0].LATITUDE, Workorderresponse.WOResponse[0].LONGITUDE)


            } else {
                $("#Makeid").attr("value", "");
                $("#Modelid").attr("value", "");
                $("#Serialid").attr("value", "");
                this.setState({ isWorkToStoreValid: false, defaultShipto: "" });
            }

            let BO = {
                AssetId: localasset,
                SHIPTO: loacalloc
            }
            // $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            //SupplierCallInAction.SupplierAsset(BO)
            this.setState({
                AssetID: localasset, Store: localstore, WONotes: localWON, Location: loacalloc, WorkOrderResponse: workorder,
                WOmsg: LWOmsg, storetruckval: loacalloc, VendorIDList: this.state.VendorIDList1, VendorDetail: this.state.VendorDetail1,
                Make: this.state.Make1, Model: this.state.Model1, SerialNo: this.state.SerialNo1, AssetName: this.state.AssetName1, isValidWO: true, shiptomessg: false
            });
            if (this.state.bill_to != true) {
                if (loacalloc.startsWith("WT")) {
                    $('#ZipCode').modal('show');
                    $('#ZipCode_no').val('');
                }
            }
        }
        else {

            $("#Makeid").attr("value", "");
            $("#Modelid").attr("value", "");
            $("#Serialid").attr("value", "");
            this.setState({
                isWorkToStoreValid: false,
                WOmsg: "Enter a valid Work Order number", defaultShipto: ""
            });
            // alert("Enter valid Work Order Number")
        }
        // this.ShipToDropdown()
    }
    setShipToDD = (lat, long) => {

        //$(`#${SDIConstants.SDILoader}`).addClass('hide');
        if (lat != undefined && long != undefined) {
            this.setState({
                billtostorelocation: {
                    lat: lat, long: long
                }
            })
        }
        this.setState({ isWorkToStoreValid: true });

        //let PerferedShipto = "";  
        let PerferedShipto = {
            value: "0",
            label: "--Select Ship To--"
        }
        let ShiptoValue = [];
        let locCountryMatch = true;
        let localloc = CookieService.getLocalStorageValues("Session_ISAShipToID") == null || CookieService.getLocalStorageValues("Session_ISAShipToID") == "" ? "0" : CookieService.getLocalStorageValues("Session_ISAShipToID");
        //this.setState({ defaultShipto: billtoStore });   
        //WW-1020 - User is able to select #1822 Ship To (PR) for #1519 Work Order (USA) - Deepthi
        let ShiptoOptions = [];
        let CountryCode = CookieService.getLocalStorageValues("LOCATION");
        if (CountryCode.toUpperCase() == "PRI") {
            ShiptoOptions = this.state.AllShipTo.filter((item, index) => item.COUNTRY.toUpperCase() == "PRI");
        }
        else {
            ShiptoOptions = this.state.AllShipTo.filter((item, index) => item.COUNTRY.toUpperCase() == CountryCode.toUpperCase());
        }
        let ShiptoDD = [];
        if (ShiptoOptions != null && ShiptoOptions != undefined) {
            if (ShiptoOptions.length > 0) {
                ShiptoOptions.map((val, index) => {
                    if (index == 0) {
                        let defaultvalue = {
                            value: "0",
                            label: "--Select Ship To--"
                        }
                        ShiptoDD.push(defaultvalue)
                    }
                    let localArray = {
                        value: val.CUSTID,
                        label: val.LOCNAME
                    }
                    ShiptoDD.push(localArray)

                });
            }
        }
        let DefShipTo = this.state.AllShipTo.filter((item, index) => item.CUSTID.toUpperCase() == localloc.toUpperCase());
        if (DefShipTo.length > 0) {
            if (CountryCode.toUpperCase() == DefShipTo[0].COUNTRY.toUpperCase()) {
                let locDefShipTo = {
                    value: DefShipTo[0].CUSTID,
                    label: DefShipTo[0].LOCNAME
                }
                PerferedShipto = locDefShipTo;
            } else {
                locCountryMatch = false;
            }

        }
        this.setState({
            BilltoStore: PerferedShipto, ShipToDDValue: ShiptoDD, defaultShipto: PerferedShipto.value === "W09301" || PerferedShipto.value === "W02409" ? { value : "0", label: "-- Select Ship To --" } : PerferedShipto, isCountryMatch: locCountryMatch,

            billtostorelocation: { lat: lat, long: long }
        })
    }
    updateFavPageResponse = () => {

        if (SupplierCallInStore.updateFavPageResponse.updateType == 1) {
            let response = JSON.parse(SupplierCallInStore.updateFavPageResponse.responseStr)[0];
            if (response.is_Success == "True") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: true, Page_ID: response.Page_ID });
                MenuAction.toastMessage(1);
            }
        } else {
            let response = JSON.parse(SupplierCallInStore.updateFavPageResponse.responseStr)[0];
            if (response.success == "true") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: false });
                MenuAction.toastMessage(2);
            }
        }
    };

    handleFavorite = (event) => {
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        this.setState({ isFavorited: event.target.checked });
        if (event.target.checked == true) {
            let insertFavPageBO = {
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                pageURL: "/suppliercallin",
                pageTitle: "Supplier Call-In",
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
            }
            SupplierCallInAction.insertFavPage(insertFavPageBO)
        } else {
            let deleteFavPageBO = {
                Page_ID: this.state.Page_ID
            }
            SupplierCallInAction.deleteFavPage(deleteFavPageBO)
        }
    };
    ShipToDropdown = () => {

        let Login_UserId = (CookieService.getLocalStorageValues("Session_AGENTUSERID") == "" ? CookieService.getLocalStorageValues("Session_UserID") : CookieService.getLocalStorageValues("Session_AGENTUSERID"));
        let Login_UserBU = (CookieService.getLocalStorageValues("Session_AGENTUSERBU") == "" ? CookieService.getLocalStorageValues("Session_BUSUNIT") : CookieService.getLocalStorageValues("Session_AGENTUSERBU"));

        let GetCartBO = {
            userID: Login_UserId,
            userBU: Login_UserBU,
            punchinSessionID: "",
            Session_USERTYPE: CookieService.getLocalStorageValues("Session_USERTYPE"),
            Session_EMAIL: CookieService.getLocalStorageValues("Session_EMAIL"),
            Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP"),
            Session_UserName: CookieService.getLocalStorageValues("Session_USERNAME"),
            Session_ACTIVEUSERS: CookieService.getLocalStorageValues("Session_ACTIVEUSERS"),
            Session_WEBSITEID: CookieService.getLocalStorageValues("Session_WEBSITEID"),
            CurrentPage_Url: "/SDIXZEUS/ShoppingCart",
            Session_PARTLIST: CookieService.getLocalStorageValues("Session_PARTLIST"),
            Session_CplusDbSQL: CookieService.getLocalStorageValues("Session_CplusDbSQL"),
            Session_MobIssuing: CookieService.getLocalStorageValues("Session_MobIssuing"),
            Session_ITEMMODE: CookieService.getLocalStorageValues("Session_ITEMMODE"),
            Session_SITEPREFIX: CookieService.getLocalStorageValues("Session_SITEPREFIX"),
            Session_CARTFAIL: "N",
            Session_USESOLRSEARCH: CookieService.getLocalStorageValues("Session_USESOLRSEARCH"),
            Session_CplusDB: CookieService.getLocalStorageValues("Session_CplusDB"),
            Session_SDICAT: CookieService.getLocalStorageValues("Session_SDICAT"),
            Session_SEARCH3M: CookieService.getLocalStorageValues("Session_SEARCH3M"),
            Session_SEARCHORONASCO: CookieService.getLocalStorageValues("Session_SEARCHORONASCO"),
            Session_SEARCHCAPP: CookieService.getLocalStorageValues("Session_SEARCHCAPP"),
            Session_SEARCHMSC: CookieService.getLocalStorageValues("Session_SEARCHMSC"),
            Session_SEARCHIMP: CookieService.getLocalStorageValues("Session_SEARCHIMP"),
            Session_SEARCHSTAUFFER: CookieService.getLocalStorageValues("Session_SEARCHSTAUFFER"),
            Session_CARTTAXEXMPTFLAG: CookieService.getLocalStorageValues("Session_CARTTAXEXMPTFLAG"),
            //WAL-1034 bug
            ShipToID: CookieService.getLocalStorageValues("HOME_STORE") != null && CookieService.getLocalStorageValues("HOME_STORE") != undefined && CookieService.getLocalStorageValues("HOME_STORE") != "" ? CookieService.getLocalStorageValues("HOME_STORE") : " ",
            Location: CookieService.getLocalStorageValues("Session_STATE") != null ? CookieService.getLocalStorageValues("Session_STATE") : "",
            Source: "WEB",
        }
        ShoppingCartAction.Getcartitem(GetCartBO);


    }

    loadFavPageResponse = () => {
        let favPageResponse = JSON.parse(SupplierCallInStore.currentFavPageResponse);
        console.log("favPageResponse", favPageResponse);
        if (favPageResponse.length > 0) {
            favPageResponse = favPageResponse[0];
            this.setState({ isFavorited: true, Page_ID: favPageResponse.PAGE_ID });
        };
    };
    CheckBillToStore = () => {

        let biltost = this.state.WorkOrderResponse;
        let defship = this.state.Store;
        let ind = defship.indexOf("#");
        let ShipToDD = this.state.ShipToDDValue;
        let ShipToVal = "W0" + defship.substring(ind + 1, defship.length);
        let defaultshipto;
        let loacalloc;
        if (this.state.isWorkToStoreValid) {
            loacalloc = CookieService.getLocalStorageValues("LOCATION")
        }
        else if (biltost[0].LOCATION != "" && biltost[0].LOCATION != null && biltost[0].LOCATION != undefined && biltost[0].LOCATION != " ") {
            loacalloc = biltost[0].LOCATION;
        }
        if (this.state.ShipToDDValue.length > 0) {
            this.state.ShipToDDValue.map((val, index) => {
                if (val.value == this.state.Location) {
                    defaultshipto = val;
                }
            });
        }
        if (this.state.bill_to == false) {

            let OLWorkOrder = this.state.WorkOrderNo;
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
            //**********NEW*************wal-158******
            let THIRDPARTY_COMP_ID = ""
            if (CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID") != null) {
                THIRDPARTY_COMP_ID = CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID")
            }
            let BO = {
                workOrder: OLWorkOrder,
                Session_THIRDPARTY_COMP_ID: THIRDPARTY_COMP_ID,
                User_Type: CookieService.getLocalStorageValues("Session_SDIEMP") //WW-336-PC_06 CBRE WO# validation is not working for SDI Users (1/18/2022)  -Aparna
            }

            //$(`#${SDIConstants.SDILoader}`).removeClass('hide');
            //SupplierCallInAction.supplierOrderEntryPageLoad(BO)
            //[12/10/21, PC_SC_01, WW-243, Dhevanesam R]
            if (defaultshipto != undefined || defaultshipto != null) {
                this.setState({ bill_to: true, defaultShipto: defaultshipto })
            }
            else {
                //[12/14/21, PC_SC_04, WW-243, Dhevanesam R]
                let loc = {
                    label: this.state.Store + " " + "-" + " " + this.state.Location,
                    value: this.state.Location
                }
                this.setState({ bill_to: true, defaultShipto: loc })
            }

        } else {

            let homestore = {};
            let billdefstoreval = "";
            let Defaultship = CookieService.getLocalStorageValues("Session_ISAShipToID") == null || CookieService.getLocalStorageValues("Session_ISAShipToID") == "" ? "0" : CookieService.getLocalStorageValues("Session_ISAShipToID");
            //this.setState({ isWorkToStoreValid: false });
            if (this.state.ShipToDDValue != null && this.state.ShipToDDValue != undefined) {
                if (this.state.ShipToDDValue.length > 0) {
                    this.state.ShipToDDValue.map((val, index) => {
                        if (val.value == Defaultship) {
                            homestore = val
                        }
                        billdefstoreval = this.state.Store;
                        this.setState({ defaultShipto: { value: "0", label: "--Select Ship To--" }})
                    });
                }
            }
            this.setState({ bill_to: false })

        }
    }
    workorderClick = () => {
        if (!this.state.WorkOrderNo) {
            this.setState({ WORmsg: true, WOmsg: false})
            return;
        }
        if (!this.state.isWorkToStoreValid) {
            this.setState({ woclick: true });
            let WorkOrderNo = $('#WorkOrderNo').val();
            if (WorkOrderNo != "" && WorkOrderNo != null && WorkOrderNo != undefined) {
                if (CookieService.getLocalStorageValues("Session_CC_VALIDATE_WO") != 'N') {
                    let THIRDPARTY_COMP_ID = ""
                    if (CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID") != null) {
                        THIRDPARTY_COMP_ID = CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID")
                    }
                    let BO = {
                        workOrder: WorkOrderNo,
                        Session_THIRDPARTY_COMP_ID: THIRDPARTY_COMP_ID,
                        User_Type: CookieService.getLocalStorageValues("Session_SDIEMP"), //WW-336-PC_07 CBRE WO# validation is not working for SDI Users (1/18/2022)  -Aparna
                        is_WO_Parts_Needed: true
                    }
                    $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                    SupplierCallInAction.supplierOrderEntryPageLoad(BO)
                }
                else {
                    this.setShipToDD(0, 0);
                    localStorage.setItem('WONum', WorkOrderNo);
                    $("#AssetID").attr("disabled", false);
                    $("#WorkOrderNo").addClass("disabledbutton"); 
                    this.setState({ isValidWO: true, VendorIDList: this.state.VendorIDList1, VendorDetail: this.state.VendorDetail1, Make: this.state.Make1, Model: this.state.Model1, SerialNo: this.state.SerialNo1, AssetName: this.state.AssetName1, WOmsg: false });
                }

            }
            else {
                this.setState({ WOmsg: true ,WORmsg: false});
                //alert("Enter valid Work Order Number");
                return;
            }
        }
    }
    removeAttachmentResponse = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let isValid = SupplierCallInStore.removeAttachmentResponse.indexOf("success") >= 0 ? true : false;
        if (isValid) {
            let tempAttachments = this.state.attachmentPathArr;
            tempAttachments.splice(rmvAttachindex, 1);
            this.setState({ attachmentPathArr: tempAttachments });
            rmvAttachindex = -1;
        }
    };
    /*
     * Ref: NC_PC_17
     * Listener method of loading attachments
     */
    loadAttachments = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        $(`#nAttachments`).val('');
        let isValid = SupplierCallInStore.attachmentResponse.indexOf("You have exceeded the length of total file names") >= 0 ? false : true;
        if (isValid) {
            let attachmentResponse = JSON.parse(SupplierCallInStore.attachmentResponse);
            let tempAttachments = this.state.attachmentPathArr;
            tempAttachments = tempAttachments.concat(attachmentResponse);
            this.setState({ attachmentPathArr: tempAttachments });
            console.log("tempAttachments", tempAttachments);
        } else {
            this.setState({
                attachmentErrormsg: "You have exceeded the length of total file names. \nPlease adjust your entry or remove longer file names."
            });
        }
    };
    removeAttachments = (filepath, index) => {
        console.log(filepath);
        rmvAttachindex = index
        let removeBO = {
            filePath: filepath
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        SupplierCallInAction.removeAttachment(removeBO);
    }
    downloadAttachment = (e, attachment) => {
        e.preventDefault();
        let downloadBO = {
            fileName: attachment.FileName,
            filePath: attachment.FilePath
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        SupplierCallInAction.downloadAttachment(downloadBO);
    };
    handleAttachment = (event) => {

        let files = event.target.files;
        //WW-311 Non - Catalog Attachments should allow attachments of type pdf or Img - Deepthi
        let filetype = files[0].type;
        if (!(filetype.toLowerCase().includes('jpg') || (filetype.toLowerCase().includes('png')) || (filetype.toLowerCase().includes('jpeg')) || (filetype.toLowerCase().includes('pdf')))) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "You can choose only the Image and PDF files!!"
            });
            // alert("You can choose only the Image and PDF files!!");
            return;
        }
        console.log("event", files);
        if (files.length > 0) {
            this.setState({ attachmentErrormsg: "" });
            if (this.state.attachmentPathArr.length > 0) {
                for (let i = 0; i < files.length; i++) {
                    let isDuplicate = this.state.attachmentPathArr.filter((attach) => attach.FileName == files[i].name).length > 0 ? true : false;
                    if (isDuplicate) {
                        //5629 - updated a validation message as Selected file is already attached. Please choose a different one [4/17/2025] Nachiappan
                        this.setState({ attachmentErrormsg: "Selected file is already attached. Please choose a different one" });
                        return false;
                    }
                }
            }
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            SupplierCallInAction.addAttachment(files);
        }
    }

    bindAttachments = () => {
        ;
        console.log("attachmentPathArr", this.state.attachmentPathArr);
        return this.state.attachmentPathArr.map((attachment, index) => {
            return (
                <span className="attachment-file-name pl-0 my-2 pr-3 d-inline-block" key={index}>
                    <a href="#" className="noncat-Attachment" data-toggle="tooltip" title={attachment.FileName} onClick={(e) => this.downloadAttachment(e, attachment)}>{attachment.FileName}</a>
                    <span className="attachment-remove-icon ml-1" onClick={() => this.removeAttachments(attachment.FilePath, index)}>X</span>
                </span>
            );
        });
    };
    handleChange = (event) => {

        let checkbox = false;
        if (event.target.name == "WorkOrderNo") {
            this.setState({ WORmsg: false, WOmsg: false })
        }
        if (event.target.name == "AssetID") {
            if (SDIConstants.assertTagIdRegex.test(event.target.value)) {
                this.setState({ [event.target.name]: event.target.value, assetmsg: false });
            }

        }
        else if (event.target.name == "VendorID") {
            document.getElementById("addressdrop").value = "";
            document.getElementById("PhoneNumID").value = "";
            if (event.target.value.toUpperCase() == "W000000076") {
                let pickupchekcbox = JSON.parse(localStorage.getItem("PickupVendor"))
                let pickupcheckdisplay = pickupchekcbox.filter((x) => x.VENDOR_ID == event.target.value)

                if (pickupcheckdisplay.length > 0) {
                    checkbox = true
                }
                this.setState({ [event.target.name]: event.target.value, vendormsg: false, phoneNumBol: false, URIFLAG: true, Pickupdisplay: checkbox });
            }
            else {
                let pickupchekcbox = JSON.parse(localStorage.getItem("PickupVendor"))
                //let pickupcheckdisplay = pickupchekcbox.filter((x) => x.VENDOR_ID == event.target.value)

                //if (pickupcheckdisplay.length > 0) {
                //    checkbox = true;
                //}


                this.setState({ [event.target.name]: event.target.value, vendormsg: false, phoneNumBol: false, URIFLAG: false, Pickupdisplay: checkbox });

            }

        }
        //[11/15/22], PC_WW-530_02, Dhevanesam R
        else if (event.target.name == "Address") {
            let AddressSplit = ""
            let Address3FieldSplitVal = ""
            if (event.target.value != "" && event.target.value != undefined && event.target.value != null) {
                AddressSplit = event.target.value.split("-")[0]
                Address3FieldSplitVal = event.target.value.split("-")[1]
            }
            this.setState({ [event.target.name]: AddressSplit, addressmsg: false, phoneNumBol: true, Address3Field: Address3FieldSplitVal });
        }
        else if (event.target.name == "supplierPrtNbr") {
            this.setState({ [event.target.name]: event.target.value, addressmsg: false, Make: event.target.value });
        }
        else if (event.target.name == "recommendedSupplier") {
            this.setState({ [event.target.name]: event.target.value, addressmsg: false, Model: event.target.value });
        }
        else if (event.target.name == "quantity") {
            this.setState({ [event.target.name]: event.target.value, addressmsg: false, SerialNo: event.target.value });
        }
        //WAL-1034_PC_30 -Aparna
        else if (event.target.name == "Notes") {
            this.setState({ [event.target.name]: event.target.value, });
        }
        else {
            const onlyNumbers = SDIConstants.quantityRegEX;
            if (event.target.value === '' || onlyNumbers.test(event.target.value)) {
                this.setState({ [event.target.name]: event.target.value });
            }
        }

        console.log("event.target.name", event.target.name);
        console.log("event.target.value", event.target.value);
    }


    keyPress(e) {
        if (e.keyCode == 13) {
            ;
            console.log("this.state.Location", $('#Locationid').val());
            //[11/9/22, WAL - 785 - Passing BU as a object, Dhevanesam R]
            if ($('#AssetID').val() != "") {
                let BO = {
                    AssetId: $('#AssetID').val(),
                    SHIPTO: $('#Locationid').val(),
                    BU: CookieService.getLocalStorageValues("Session_BUSUNIT")
                }
                $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                SupplierCallInAction.SupplierAsset(BO)
            }
            else {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Please enter Asset Id"
                });
                // alert("Please enter Asset Id");
            }

        }
    }
    vendorDD = () => {
        if (this.state.VendorIDList.length > 0) {
            return this.state.VendorIDList.map((val, index) => {
                return (<option key={val.VENDOR_ID} value={val.VENDOR_ID}>{val.NAME1}</option>)
            });
        }

    };
    trucklatlong = () => {

        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let LatLongResp_Data = JSON.parse(ShoppingCartStore.getlatlongresp);
        let latitude = LatLongResp_Data[0].Latitude;
        let longitude = LatLongResp_Data[0].Longitude;
        this.setState({ curtrucklat: latitude, curtrucklong: longitude })

    }
    ZipCodeClick = () => {

        let postal_code = $('#ZipCode_no').val();
        if (postal_code != "") {
            $('#ZipCode').modal('hide');
            let zipcodeBO = {
                ZipCode: postal_code
            }
            //$(`#${SDIConstants.SDILoader}`).removeClass('hide');
            ShoppingCartAction.Gettrucklatlong(zipcodeBO);

        }
        else {
            document.getElementById("ErrorMagUserId").innerText = "Please Enter a valid Zip Code"
        }
    }
    //ZipCodeClose = () => {
    //    document.getElementById("ErrorMagUserId").innerText = ""
    //    let postal_code = $('#ZipCode_no').val();
    //    if (postal_code != "") {
    //        $("#pickupcheck").prop("checked", false);
    //        this.setState({ pickupcheck: "" });
    //    }
    //    else {
    //        $("#pickupcheck").prop("checked", false);
    //        this.setState({ pickupcheck: "" });
    //    }
    //}
    distance = (lat1, lon1, lat2, lon2, unit) => {
        var radlat1 = Math.PI * lat1 / 180
        var radlat2 = Math.PI * lat2 / 180
        var theta = lon1 - lon2
        var radtheta = Math.PI * theta / 180
        var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
        dist = Math.acos(dist)
        dist = dist * 180 / Math.PI
        dist = dist * 60 * 1.1515
        if (unit == "K") { dist = dist * 1.609344 }
        if (unit == "M") { dist = dist * 0.8684 }
        return dist
    }
    AddressDD = () => {
        let vendorid = this.state.VendorID;/*.map((val, index)*/
        let addr = []
        let curlat = 0;
        let curlong = 0;
        let billtostore = this.state.billtostorelocation;
        if (billtostore.lat != undefined && billtostore.long != undefined) {
            curlat = billtostore.lat;
            curlong = billtostore.long;
        }
        let billstore = this.state.storetruckval;
        if (billstore.startsWith("WT")) {
            curlat = this.state.curtrucklat;
            curlong = this.state.curtrucklong;
        }
        addr = this.state.VendorDetail.filter((x) => x.VENDOR_ID == vendorid)
        console.log("addr", addr);
        //[11/15/22], PC_WW-530_01, Dhevanesam R
        if (addr.length > 0) {
            return addr.sort((a, b) => this.distance(curlat, curlong, a.LATITUDE, a.LONGITUDE, "KM") > this.distance(curlat, curlong, b.LATITUDE, b.LONGITUDE, "KM") ? 1 : -1).map((iresult, index) => {

                if (iresult != null && iresult != undefined) {
                    let dis = Math.round(this.distance(curlat, curlong, iresult.LATITUDE, iresult.LONGITUDE, "KM") * 0.62);
                    //let arr1 = iresult.address1 + "," + iresult.state + " " + dis + " " + "miles";
                    let totaldis = "";
                    if (CookieService.getLocalStorageValues("Session_CC_VALIDATE_WO") != 'N') {
                        totaldis = dis + " miles";
                    }
                    return (<option key={index} value={`${iresult.ADDRESS1}-${iresult.ADDR_FIELD3}`}>{`${iresult.ADDRESS1},${iresult.CITY},${iresult.STATE},${totaldis}`}</option>)
                }
            });
        }
    }
    phoneNo = () => {

        let vendorid = this.state.VendorID;
        let addr = this.state.Address;
        let phone = [];
        let ph = ""
        //[11/15/22], PC_WW-530_03, Dhevanesam R
        phone = this.state.VendorDetail.filter((x) => x.VENDOR_ID == vendorid && x.ADDRESS1 == addr && x.ADDR_FIELD3 == this.state.Address3Field)
        console.log("phone", phone);
        if (phone != "" && phone != null && phone != undefined && phone != " ") {
            if (phone[0].PHONE != "" && phone[0].PHONE != null && phone[0].PHONE != undefined && phone[0].PHONE != " ") {
                console.log("phone", phone[0].PHONE);
                if (this.state.phoneNumBol == true) {
                    return (<div className="col-md-6 px-0">
                        <input type="text" className="form-control" maxLength="30" id="PhoneNumID" value={phone[0].PHONE} name="Phoneno" onChange={this.handleChange} disabled />
                    </div>);
                    this.setState({ Phoneno: phone[0].PHONE });
                }
                else {
                    return (<div className="col-md-6 px-0">
                        <input type="text" className="form-control" maxLength="30" id="PhoneNumID" value={ph} name="Phoneno" onChange={this.handleChange} disabled /> </div>);
                    this.setState({ Phoneno: "" });
                }
            }
            else {
                return (<div className="col-md-6 px-0">
                    <input type="text" className="form-control" maxLength="30" id="PhoneNumID" value={ph} name="Phoneno" onChange={this.handleChange} disabled /> </div>);
                this.setState({ Phoneno: "" });
            }
        }
        else {
            return (<div className="col-md-6 px-0">
                <input type="text" className="form-control" maxLength="30" id="PhoneNumID" value={ph} name="Phoneno" onChange={this.handleChange} disabled /> </div>);
            this.setState({ Phoneno: "" });
        }

    }
    submitBtnClick = (e) => {
        e.preventDefault();
        let validationmsg = false;
        let assetmsg = false;
        let vendormsg = false;
        let addrsmsg = false;
        let LWOmsg = false;
        //5629 - when wo not entered and submitting validation message will display. [4/17/2025] Nachiappan
        let WORmsg = false;
        let shiptomsg = false;
        if (this.state.WorkOrderNo == "" || this.state.WorkOrderNo == " " || this.state.WorkOrderNo == null || this.state.WorkOrderNo == undefined) {
            validationmsg = true;
            LWOmsg = true;
        }
        //***BUG 1499 (9/22/2021)
        // if (this.state.AssetID == "" || this.state.AssetID == " " || this.state.AssetID == null || this.state.AssetID == undefined) {
        //    validationmsg = true;
        //    assetmsg = true;
        //}
        if (this.state.VendorID == "" || this.state.VendorID == " " || this.state.VendorID == null || this.state.VendorID == undefined || this.state.VendorID == "0") {
            vendormsg = true;
            validationmsg = true;
        }
        if (this.state.Address == "" || this.state.Address == " " || this.state.Address == null || this.state.Address == undefined) {
            addrsmsg = true;
            validationmsg = true;
        }
        if (this.state.defaultShipto.value == undefined || this.state.defaultShipto.value == "0") {
            shiptomsg = true;
            validationmsg = true;
        }
        if (validationmsg) {
            if (LWOmsg) {
                this.setState({
                    WorkOrderNo: "",
                    WorkOrderResponse: [],
                    VendorIDList: [], VendorDetail: [], Make: "", Model: "", SerialNo: "", AssetName: "",
                    AssetID: "", Store: "", WONotes: "", Location: "", Notes: "",
                    WORmsg: LWOmsg,
                    assetmsg: assetmsg,
                    vendormsg: vendormsg,
                    addressmsg: addrsmsg,
                    //5631 - when submitting without work order then shiptomsg should not be displayed [4/16/2025] Nachiappan
                    //shiptomessg: shiptomsg,
                });
            }
            else {
                this.setState({
                    WOmsg: LWOmsg,
                    assetmsg: assetmsg,
                    vendormsg: vendormsg,
                    addressmsg: addrsmsg,
                    shiptomessg: shiptomsg,
                });
            }

            return;
        }
        else {
            //this.setState({
            //    assetmsg: false,
            //    vendormsg: false,
            //    addressmsg: false,
            //});
            let vendorid = this.state.VendorID;
            let row = [];
            let displayName = "";
            row = this.state.VendorDetail.filter((x) => x.VENDOR_ID == vendorid && this.state.Address == x.ADDRESS1 && x.ADDR_FIELD3 == this.state.Address3Field)
            if (CookieService.getLocalStorageValues("Session_USERNAME")) {
                displayName = CookieService.getLocalStorageValues("Session_USERNAME").indexOf(",") >= 0 ? CookieService.getLocalStorageValues("Session_USERNAME").split(",")[1] + " " + CookieService.getLocalStorageValues("Session_USERNAME").split(",")[0] : CookieService.getLocalStorageValues("Session_USERNAME");
                if (CookieService.getLocalStorageValues("Session_AGENTUSERID") != "" && CookieService.getLocalStorageValues("Session_AGENTUSERID")) {
                    if (CookieService.getLocalStorageValues("Session_USERTYPE") == "ADMINX") {
                        displayName = displayName + CookieService.getLocalStorageValues("Session_CONAME");
                    } else {
                        displayName = displayName + CookieService.getLocalStorageValues("Session_AGENTUSERNAME");
                    }
                }
            };
            console.log("displayName", displayName)
            console.log("row", row)
            console.log("Session_EMAIL", CookieService.getLocalStorageValues("Session_EMAIL"))
            console.log("Session_PHONE", CookieService.getLocalStorageValues("Session_PHONE"))

            let samval = this.state.defaultShipto.value
            if (samval == undefined || samval == "0") {
                samval = this.state.Location
            }

            if (row[0].ADDR_FIELD3 == " " || row[0].ADDR_FIELD3 == null || row[0].ADDR_FIELD3 == "" || row[0].ADDR_FIELD3 == undefined) {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Request cannot be submitted for this Vendor"
                });
                //alert("Request cannot be submitted for this Vendor");
                return;
            }
            else {
                let attachmentStr = "";
                if (this.state.attachmentPathArr.length > 1) {
                    this.state.attachmentPathArr.map((val, index) => {
                        if (attachmentStr != "") {
                            attachmentStr = attachmentStr + "|" + val.FilePath
                        } else {
                            attachmentStr = val.FilePath
                        }

                    });

                    if (attachmentStr.length > 254) {
                        this.setState({
                            attachmentErrormsg: "You have exceeded the length of total file names. \nPlease adjust your entry or remove longer file names."
                        });
                        return false;
                    }
                } else {
                    this.state.attachmentPathArr.map((val, index) => {
                        attachmentStr = val.FilePath
                    });
                }
                let BO = {
                    userID: (CookieService.getLocalStorageValues("Session_AGENTUSERID") == "" ? CookieService.getLocalStorageValues("Session_UserID") : CookieService.getLocalStorageValues("Session_AGENTUSERID")),
                    BU: (CookieService.getLocalStorageValues("Session_AGENTUSERBU") == "" ? CookieService.getLocalStorageValues("Session_BUSUNIT") : CookieService.getLocalStorageValues("Session_AGENTUSERBU")),
                    REQUEST_ID: "",
                    WORKORDER: this.state.WorkOrderNo,
                    SHIPTO: samval,
                    WOStore: CookieService.getLocalStorageValues("Session_CC_VALIDATE_WO") == 'N' && this.state.Location == "" ? " " : this.state.Location,
                    ASSETID: this.state.AssetID,
                    VENDORID: this.state.VendorID,
                    WOCOMMENTS: this.state.WONotes,
                    USERCOMMENTS: this.state.Notes,
                    MAKE: this.state.Make,
                    Address1: this.state.Address,
                    Suppliername: row[0].NAME1,
                    ADDR_FIELD3: row[0].ADDR_FIELD3,
                    MODEL: this.state.Model,
                    SERIALNO: this.state.SerialNo,
                    TechName: displayName,
                    TechEmailId: CookieService.getLocalStorageValues("Session_EMAIL"),
                    TechPhNo: CookieService.getLocalStorageValues("Session_PHONE"),
                    URIFLAG: true,
                    PICKUPFLAG: this.state.pickupcheck,
                    CustomerID: "11411777",
                    Assetname: this.state.AssetName,
                    FilePath: attachmentStr,
                    IsWeb: true,
                    WO_TYPE: CookieService.getLocalStorageValues("WO_Type") == "" || CookieService.getLocalStorageValues("WO_Type") == undefined || CookieService.getLocalStorageValues("WO_Type") == null ? 'WALMART' : CookieService.getLocalStorageValues("WO_Type"),
                    Emp_Name: CookieService.getLocalStorageValues("Session_USERNAME")

                }
                console.log("BO", BO)
                $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                SupplierCallInAction.SupplierInsert(BO);
                //[02/09/24, 4059 - Remove the ship to field after submit the order - Nandhini]
                this.setState({
                    defaultShipto: "", isWorkToStoreValid: false, bill_to: false
                })
            }

        }
    }
    CancelBtnClick = () => {
        localStorage.removeItem('WONum')
        localStorage.removeItem('WOAssetID') /*[04/10/23, PC_4247_06 - To remove the localStorage Item "WOAssetID", Vishwa S]*/
        localStorage.removeItem('StoreValue')
        localStorage.removeItem('WO_Parts')//BUG:3618 -Aparna
        //[10/18/22, WAL - 785 Getting Asset Tag and storing in a cookie value, Dhevanesam R
        CookieService.updateLocalStorageValues("AssetTag", "");
        CookieService.updateLocalStorageValues("AssetID", "");
        CookieService.updateLocalStorageValues("Trade", "");
        CookieService.updateLocalStorageValues("Category", "");
        CookieService.updateLocalStorageValues("Make", "");
        CookieService.updateLocalStorageValues("Model", "");
        // CookieService.updateLocalStorageValues("WO_Parts", "");//BUG:3618 -Aparna
        CookieService.updateLocalStorageValues("WO_Address", "");
        localStorage.removeItem('WOAssetTag')
        CookieService.updateLocalStorageValues("WO_Make", "");
        CookieService.updateLocalStorageValues("WO_Model", "");
        CookieService.updateLocalStorageValues("Session_WO_STATE", ""); //WW-1231 WO State Restriction -Vishwa S
        $("#WorkOrderNo").removeClass("disabledbutton");
        $("#AssetID").attr("disabled", true); //Bug-5496 -Vishwa S
        this.setState({
            woclick: false, isValidWO: false, WORmsg: false,
            AssetID: "NONE", assetmsg: false, defaultShipto: "", attachmentPathArr: [], attachmentErrormsg: "", isWorkToStoreValid: false, bill_to: false, WOmsg:false,  // Bug -5598 - K. Surya
            VendorID: "0", Pickupdisplay: false, Address: "", Phoneno: "", vendormsg: false, addressmsg: false, shiptomessg: false, Notes: "", Make: "", Model: "", SerialNo: "", WorkOrderNo: "", WorkOrderResponse: [], Store: "", Location: "", VendorIDList: []
        });
    }
    handleChangeShipto = (values) => {

        this.setState(
            { defaultShipto: values, shiptomessg: false })
    }
    pickupchange = (e) => {
        //[12/10/21, PC_SC_02, WW-243, Dhevanesam R]

        if (e.target.checked == true) {
            let defship = this.state.Store;
            let ind = defship.indexOf("#");
            // let ShipToVal = "W0" + defship.substring(ind + 1, defship.length);
            let location = this.state.Location
            let defaultshipto;
            if (this.state.ShipToDDValue.length > 0) {
                this.state.ShipToDDValue.map((val, index) => {
                    if (val.value == location) { // WW-243 (Call In Urn Request Submission) (12/2/2021) *changed "ShipToVal" to "location"
                        defaultshipto = val;
                    }
                });
            }

            if (e.target.checked && (defaultshipto != undefined || defaultshipto != null)) {
                this.setState({ pickupcheck: true, defaultShipto: defaultshipto, shiptomessg: false });
            }
            //[12/14/21, PC_SC_04, WW-243, Dhevanesam R]
            else {
                let loc = {
                    label: this.state.Store + " " + "-" + " " + this.state.Location,
                    value: this.state.Location
                } // WW-243 (Call In Urn Request Submission) (12/2/2021) 
                //[12/14/21, PC_SC_03, WW-243, Dhevanesam R]
                this.setState({ pickupcheck: true, defaultShipto: loc, shiptomessg: false});
            }
        }
        else {
            //[02/28/24, 4831 Shipto not working properly - Nandhini L]
            this.setState({ pickupcheck: false, bill_to: false, defaultShipto: "" });
        }

    }
    /***
 * 
 * */
    WO_Parts_ButtonClick = () => {
        $('#WO_Parts_Popup').modal('show');
    }
    WOClose = () => {
        $('#WO_Parts_Popup').modal('hide');
    }
    //WAL-1034_PC_38 -Aparna
    AnykeyPress(e) {
        if (e.keyCode == 13) {
            this.WOText.current.blur();
            this.workorderClick();
        }
    };
    render() {

        const { t } = this.props;
        let billtostore = this.state.Store;
        return (

            <div className="container-fluid content-section">
                <div className="row">
                    <div className="container-fluid content-margin">
                        <div className="row non-catalog-req-form">
                            <div className="col-md-12 page-heading mb-3">
                                <h5 className="page-title"><Trans>supplier_callin</Trans></h5>
                                <div className="fav-item-maintenance-icon mt-1">
                                    <input type="checkbox" id="checkbox-1" className="checknow" name="isFavorited" checked={this.state.isFavorited} onChange={this.handleFavorite} />
                                    <label htmlFor="checkbox-1">
                                        <svg className="heart-svg" viewBox="467 392 58 57" xmlns="http://www.w3.org/2000/svg">
                                            <g className="Group" fill="none" fillRule="evenodd" transform="translate(467 392)">
                                                <path d="M29.144 20.773c-.063-.13-4.227-8.67-11.44-2.59C7.63 28.795 28.94 43.256 29.143 43.394c.204-.138 21.513-14.6 11.44-25.213-7.214-6.08-11.377 2.46-11.44 2.59z" className="heart" fill="#fff" />
                                                <circle className="main-circ" fill="#E2264D" opacity={0} cx="29.5" cy="29.5" r="1.5" />
                                                <g className="grp7" opacity={0} transform="translate(7 6)">
                                                    <circle className="oval1" fill="#9CD8C3" cx={2} cy={6} r={2} />
                                                    <circle className="oval2" fill="#8CE8C3" cx={5} cy={2} r={2} />
                                                </g>
                                                <g className="grp6" opacity={0} transform="translate(0 28)">
                                                    <circle className="oval1" fill="#CC8EF5" cx={2} cy={7} r={2} />
                                                    <circle className="oval2" fill="#91D2FA" cx={3} cy={2} r={2} />
                                                </g>
                                                <g className="grp3" opacity={0} transform="translate(52 28)">
                                                    <circle className="oval2" fill="#9CD8C3" cx={2} cy={7} r={2} />
                                                    <circle className="oval1" fill="#8CE8C3" cx={4} cy={2} r={2} />
                                                </g>
                                                <g className="grp2" opacity={0} transform="translate(44 6)">
                                                    <circle className="oval2" fill="#CC8EF5" cx={5} cy={6} r={2} />
                                                    <circle className="oval1" fill="#CC8EF5" cx={2} cy={2} r={2} />
                                                </g>
                                                <g className="grp5" opacity={0} transform="translate(14 50)">
                                                    <circle className="oval1" fill="#91D2FA" cx={6} cy={5} r={2} />
                                                    <circle className="oval2" fill="#91D2FA" cx={2} cy={2} r={2} />
                                                </g>
                                                <g className="grp4" opacity={0} transform="translate(35 50)">
                                                    <circle className="oval1" fill="#F48EA7" cx={6} cy={5} r={2} />
                                                    <circle className="oval2" fill="#F48EA7" cx={2} cy={2} r={2} />
                                                </g>
                                                <g className="grp1" opacity={0} transform="translate(24)">
                                                    <circle className="oval1" fill="#9FC7FA" cx="2.5" cy={3} r={2} />
                                                    <circle className="oval2" fill="#9FC7FA" cx="7.5" cy={2} r={2} />
                                                </g>
                                            </g>
                                        </svg>
                                    </label>
                                </div>
                            </div>
                            <div className="col-md-12 form-container d-none">
                                <span className="float-right indicate-alert"><Trans>Required_key</Trans></span>
                            </div>
                            <div className="col-md-6 mb-4">
                                <div className="row">
                                    <div className="col-md-6 input-group charge-code-group pr-0">
                                        <input type="text" className="form-control charge-code-control" maxLength="9" onKeyDown={this.AnykeyPress} ref={this.WOText} placeholder="Search by Work order" value={this.state.WorkOrderNo} name="WorkOrderNo" id="WorkOrderNo" onChange={this.handleChange} />
                                        {this.state.WorkOrderNo != undefined && this.state.WorkOrderNo != null && this.state.WorkOrderNo != "" && this.state.WorkOrderNo != " " ?
                                            < span class="search-cancel-header cursor-pointer" style={{ right: "58px" }} onClick={() => this.CancelBtnClick()} ></span> : null
                                        }
                                        <div className="input-group-append">
                                            <span className="input-group-text">
                                                <span className="shopping-search-icon" onClick={this.workorderClick} />
                                            </span>
                                        </div>

                                    </div>
                                    {this.state.isValidWO && this.state.WO_Parts.length > 0 ? <div className="col-md-5">
                                        <button class="btn btn-labeled btn-primary custom-btn-primary ShoppingCart-Top-Button primary-btn" onClick={e => this.WO_Parts_ButtonClick(e)} >
                                            <img src="Images/history_icon.svg" alt="History-icon" /> WO# History</button>
                                    </div> : null}

                                    {/* Regression Bug - 5495 Enter valid work order space UI issues  - K. Surya */}
                                </div>
                                {    /*5629 - Validation mesaage [5/8/2025] Nachiappan*/
                                    (this.state.WORmsg || this.state.WOmsg) && (
                                    <span className="err-msg text-danger bold ml-2" id="womsg">
                                        <Trans>
                                            {this.state.WORmsg ? "Enter a work order number" : "Enter valid work order number"}
                                        </Trans>
                                    </span>
                                )}
                            </div>
                            {this.state.isWorkToStoreValid == true && this.state.pickupcheck == false ? <div className="col-md-6 mb-4">
                                <div className="row">
                                    <label className="col-md-6 col-lg-3 form-label catalog-label">{this.state.OLShipToIdLabel}</label>
                                    <div className=" col-md-6 px-0">
                                        <Select
                                            id="OLShipTo"
                                            className={this.state.isWorkToStoreValid ? "DropDown-Font-Size " : "DropDown-Font-Size disabled"}
                                            value={this.state.defaultShipto}
                                            onChange={(e) => this.handleChangeShipto(e)}
                                            options={this.state.ShipToDDValue}
                                            isDisabled={this.state.bill_to}
                                        /> 
                                        {!this.state.isCountryMatch ? (
                                            <div class="w-100 pt-2">
                                                <div style={{ "display": "flex", "align-items": "start" }}>
                                                    <img class="mr-2 align-top" src="Images/info-icon.png" style={{ "display": "inline" }} />
                                                    <label class="confirm-content shipment-font" style={{ "vertical-align": "middle" }}>The default Ship-To's Country Code does not match the Work Order Store Country Code.</label>
                                                </div>
                                            </div>) : null}

                                        {CookieService.getLocalStorageValues("Session_CC_VALIDATE_WO") != 'N' ? <div className="custom-control custom-checkbox item-custom-control col-md-12 px-3">
                                            <div className="mt-2 bill-to-store ml-2">
                                                <input type="checkbox" className="custom-control-input " id="Billtostoreid" name="example4" />
                                                <label className="custom-control-label catalog-label priority-checkbox" htmlFor="Billtostoreid" checked={this.state.isWorkToStoreValid} onClick={() => this.CheckBillToStore()}>Bill-to-Store</label>
                                            </div>
                                        </div> : null}
                                        {this.state.shiptomessg ? <span className="err-msg text-danger  bold"  >&nbsp;<Trans>Please select a ship to</Trans></span> : null}
                                    </div>
                                </div>

                            </div> : <div className="col-md-6 mb-4"></div>}
                            <span className="float-left err-msg text-danger col-md-12 text-center bold mb-3 d-none" id="nonCatalogSaveSuccess"><Trans>Item has been added to cart</Trans></span>
                            <div className="col-md-6 mb-4">
                                <div className="row">
                                    <label className="col-md-6 col-lg-3 form-label catalog-label"><Trans>Store</Trans></label>
                                    <div className="col-md-6 px-0">
                                        <input type="text" className="form-control" name="mfgName" maxLength="30" placeholder="Enter Name" value={this.state.Store} id="Storeid" disabled />
                                        <input type="text" className="form-control d-none" name="mfgName" maxLength="30" placeholder="Enter Name" value={this.state.Location} id="Locationid" disabled />

                                        <span className="float-left err-msg text-danger d-none">Please enter store</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 mb-4">
                                <div className="row">
                                    <label className="col-md-6 col-lg-3 form-label catalog-label"><Trans>Employee</Trans><span> </span><Trans>ID</Trans></label>
                                    <div className="col-md-6 px-0">
                                        <input type="text" className="form-control" name="mfgPartNumber" maxLength="50" placeholder="Enter Value" value={this.state.EmployeeID} id="Employeeid" disabled />
                                        <span className="float-left err-msg text-danger d-none"><Trans>Please enter</Trans><Trans>manufacturerpartnumber</Trans></span>
                                    </div>
                                </div>
                            </div>


                            {this.state.isWorkToStoreValid ? <div className="col-md-6 mb-4">
                                <div className="row">
                                    <label className="col-md-6 col-lg-3 form-label catalog-label"><Trans>Make</Trans></label>
                                    <div className="col-md-6 px-0 ">
                                        <input type="text" className="form-control" maxLength="100" value={this.state.Make} name="supplierPrtNbr" id="Makeid" onChange={this.handleChange} />
                                    </div>
                                </div>
                            </div> : <div className="col-md-6 mb-4">
                                    <div className="row">
                                        <label className="col-md-6 col-lg-3 form-label catalog-label"><Trans>Make</Trans></label>
                                        <div className="col-md-6 px-0 ">
                                            <input type="text" className="form-control" maxLength="100" value={this.state.Make} name="supplierPrtNbr" id="Makeid" disabled />
                                        </div>
                                    </div>
                                </div>}
                            {this.state.isWorkToStoreValid ? <div className="col-md-6 mb-4">
                                <div className="row">
                                    <label className="col-md-6 col-lg-3 form-label catalog-label"><Trans>Model</Trans></label>
                                    <div className="col-md-6 px-0">
                                        <input type="text" className="form-control" maxLength="30" value={this.state.Model} name="recommendedSupplier" id="Modelid" onChange={this.handleChange} />
                                    </div>
                                </div>
                            </div> : <div className="col-md-6 mb-4">
                                    <div className="row">
                                        <label className="col-md-6 col-lg-3 form-label catalog-label"><Trans>Model</Trans></label>
                                        <div className="col-md-6 px-0">
                                            <input type="text" className="form-control" maxLength="30" value={this.state.Model} name="recommendedSupplier" id="Modelid" disabled />
                                        </div>
                                    </div>

                                </div>}
                            <div className="col-md-6 mb-4">
                                <div className="row">
                                    {/*5629 - changed into a camel case [4/17/2025] Nachiappan */}
                                    <label className="col-md-6 col-lg-3 form-label catalog-label"><Trans>Asset tag ID</Trans></label>
                                    <div className="col-md-6 px-0">
                                        <input type="text" className="form-control" id="AssetID" placeholder="Enter Asset ID" name="AssetID" maxlength="45" value={this.state.AssetID} onChange={this.handleChange} />{/*****onKeyDown={this.keyPress} onChange={this.handleChange}****/}
                                        {/*<span className="float-left err-msg notes-black" ><Trans>Enter NONE If Asset ID Not Available</Trans></span> */}
                                        {this.state.assetmsg ? <span className="float-left err-msg text-danger" >&nbsp;<Trans>Please enter</Trans><Trans>Asset tag ID</Trans></span> : null}
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 mb-4">
                                <div className="row">
                                    <label className="col-md-6 col-lg-3 form-label catalog-label"><Trans>Serial</Trans><span>  #</span> </label>
                                    <div className="col-md-6 px-0">
                                        {this.state.isWorkToStoreValid != "" ? <input type="text" className="form-control" maxLength="8" name="quantity" value={this.state.SerialNo} id="Serialid" onChange={this.handleChange} /> : <input type="text" className="form-control" maxLength="8" name="quantity" value={this.state.SerialNo} id="Serialid" disabled />}
                                        <span className="float-left err-msg text-danger d-none"><Trans>Please Enter</Trans><Trans>quantity_key</Trans></span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 mb-4">
                                <div className="row">
                                    <label className="col-md-6 col-lg-3 form-label catalog-label"><Trans>Vendor</Trans><span> </span> <Trans>ID</Trans></label>
                                    <div className="col-md-6 px-0">
                                        <select className="form-control" name="VendorID" onChange={this.handleChange} >
                                            <option value="0">Select</option>
                                            {this.vendorDD()}
                                        </select>
                                        {this.state.vendormsg ? <span className="err-msg text-danger  bold"><Trans>Please select</Trans><span> </span><Trans>Vendor</Trans><span> </span> <Trans>ID</Trans></span> : null}
                                        {/* {this.state.isInvalid && this.state.uom == "" ? <span className="float-left err-msg text-danger">Please select UOM</span> : null}*/}
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 mb-4">
                                <div className="row">
                                    <label className="col-md-6 col-lg-3 form-label catalog-label"><Trans>Address</Trans></label>
                                    {/* <input type="file" class="float-left col-md-7 form-control"/> */}
                                    <div className="col-md-6 px-0 custom-file mb-3">
                                        <select className="form-control" name="Address" id="addressdrop" onChange={this.handleChange}>
                                            <option value="">Select</option>
                                            {this.state.VendorID != "0" ? this.AddressDD() : null}
                                        </select>
                                        {this.state.addressmsg ? <span className="err-msg text-danger  bold"><Trans>Please</Trans><Trans> select</Trans><span> </span><Trans> address</Trans></span> : null}
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 mb-4">
                                <div className="row">
                                    <label className="col-md-6 col-lg-3 form-label catalog-label"><Trans>Phone</Trans><span> #</span></label>

                                    {this.phoneNo()}
                                </div>

                            </div>
                            <div className="col-md-6 mb-4">
                                <div className="row">
                                    <label className="col-md-6 col-lg-3 form-label catalog-label"><Trans>Notes</Trans></label>
                                    <div className="col-md-6 px-0">
                                        <textarea className="form-control" maxLength="254" name="Notes" value={this.state.Notes} onChange={this.handleChange} />
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-6 mb-4">
                                <div className="row">
                                    <label className="col-md-6 col-lg-3 form-label catalog-label"><Trans>attachment_key</Trans></label>
                                    {/* <input type="file" class="float-left col-md-7 form-control"/> */}
                                    <div className="col-md-6 mb-3 p-0 ">
                                        <input type="file" className="custom-file-input" title=" " accept="application/pdf, image/jpeg, image/png" id="nAttachments" name="filename" onChange={this.handleAttachment} />
                                        <label className="custom-file-label" htmlFor="customFile"><Trans>ChooseFile</Trans></label>
                                        {this.bindAttachments()}
                                        <div className="err-msg text-danger bold ">{this.state.attachmentErrormsg}</div>
                                    </div>
                                </div>
                            </div>

                            {this.state.Pickupdisplay == true ?
                                <div className="custom-control custom-checkbox my-2 pl-3 float-left pr-0 item-custom-control col-md-12 float-left mrg">
                                    <input type="checkbox" className="custom-control-input " id="pickupcheck" name="example3" onChange={e => this.pickupchange(e)} />
                                    <label className="custom-control-label catalog-label priority-checkbox " htmlFor="pickupcheck"><Trans>Pickup</Trans></label>

                                </div> : null}
                            <div className="col-md-12 col-sm-auto col-auto col-lg-12 text-right">
                                <button className="btn btn-secondary custom-btn-secondary secondary-btn px-5" onClick={this.CancelBtnClick} ><Trans>Clear</Trans></button>
                                <button className="btn btn-primary custom-btn-primary primary-btn px-5 ml-3" onClick={e => this.submitBtnClick(e)} ><Trans>Submit</Trans></button>
                            </div>

                        </div>
                    </div>
                </div>
                <div className="modal userid" id="ZipCode" data-backdrop="static" data-keyboard="false">
                    <div className="modal-dialog  custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            {/* Modal Header */}
                            <div className="modal-header">
                                <h4 className="modal-title mt-1"><Trans>Zip Code</Trans></h4>
                                <button type="button" className="btn close-btn" data-dismiss="modal" /*onClick={() => this.ZipCodeClose()}*/>
                                    X
              </button>
                            </div>
                            {/* Modal body */}
                            <div className="modal-body">
                                <div className="row justify-content-center">
                                    <div className="col-md-10 float-left my-5">
                                        <label className="float-left col-md-3 form-label catalog-label pl-0"><Trans>Zip Code</Trans></label>
                                        <div className="float-left col-md-9">
                                            <input type="text" className="form-control " placeholder="Enter Zip Code" id="ZipCode_no" maxLength="10" />
                                            <span id="ErrorMagUserId" className="DropDown-Font-Size errorcolour"></span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12 text-center mb-2">

                                    <button className="btn btn-primary custom-btn-primary primary-btn px-4 mr-2" onClick={() => this.ZipCodeClick()}><Trans>OK</Trans></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/**************END***************/}
                {/* WAL-1034_PC_13 WO parts */}
                <div className="modal" id="WO_Parts_Popup" >
                    {this.state.isValidWO && this.state.WO_Parts.length > 0 ?
                        <WOPartsComponent closePopup={this.WOClose}  {...this.props} /> : null}
                </div>
            </div>
        );
    };
}

export default withTranslation()(SupplierCallInComponent);